import { useNavigate } from 'react-router-dom';
import {useGetClassesQuery} from '../../../../store/api/courseApi';
import {RootState} from '../../../../store/store';
import {useSelector} from 'react-redux';

export const useStudentDashboard = () => {
  const {categories} = useSelector((state: RootState) => state.master);
  const navigate = useNavigate();
  const {data: classes, isLoading, error, refetch} = useGetClassesQuery();
  
  const openMenu = () => {
    navigate('/MenuScreen');
  };

  return {
    data: classes || [], // Return empty array if no data yet
    openMenu,
    isLoading,
    error,
    refetch,
    categories,
  };
};
